import React, { Component } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import { NavItem, NavLink } from "reactstrap";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import SettingMenu from "../component/SettingMenu";
import UserProfileAdditional from "../component/UserProfileAdditional";

class SettingsPreferences extends Component {
  render() {
    return (
      <div>
        <Header />
        <PageTitle />
        <div className="settings mb-80">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-md-4">
                <SettingMenu />
              </div>
              <div className="col-xl-9 col-md-8">
                <div className="row">
                  <UserProfileAdditional/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SettingsPreferences;
